export default __webpack_public_path__ + "static/media/videos.689e229d.svg";